import React, { MouseEvent, useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-modal';
import './App.css';
import './CarbonStyles.scss';
import { createScenario, updateScenario, fetchScenarios, publishScenario, copyScenario, deleteScenario } from './features/scenarioSlice'
import { createInjects, fetchInjects, updateNodes, updateInject, fetchImages, deleteInject } from './features/injectSlice'

import InjectNodeMenu from './components/InjectNodeMenu'
import TurnTimeline from './components/TurnTimeline'
import NodeTimeline from './components/NodeTimeline'
import ScenarioSettings from './components/ScenarioSettings'
import { useAppSelector, useAppDispatch } from './app/hooks'
import { Scenario, Inject, ScheduledInjects, NewInjectObj, NewNode, CreateNode, NewCOA, RFI, InjectNode, COA, LastSave, TurnBrief } from './Classes1';
import { IScenario, IInject, IScheduledInjects, IInjectNode, INewNode, ICreateNode, INewCOA, IRFI, ICOA, IInjInfo, ILastSave, INodeSave, ITurnBrief, IGameStatus } from './interfaces';
import Header from './components/Header'
import Dropzone from './components/Dropzone'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { debounce, isEmpty, isEqual, isEqualWith, omit, sortBy } from 'lodash';

import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import { isAxiosError } from 'axios';

import { ToastNotification } from '@carbon/react';
import { Theme } from '@carbon/react';
import {
  Copy as CopyIcon,
  TrashCan as DeleteIcon,
  Locked as LockedIcon
} from '@carbon/icons-react';
import { selectGamesSlice } from './features/player/gameSlice';

const myFirstId = 'first-DnD-Containier';
const mySecondId = 'second-DnD-Containier';

class injObjType {
  id: string = '';
  injectId: string = '';
  image: string = '';
  localImage: string = '';
  global: boolean = false;
  turnLength: number = 1;
  name: string = '';
  description: string = '';
  owner: string = '';
  startTurn: number = 0;
  turnOrder: number = 0;
  nodes: IInjectNode[] = [];
  published: boolean | undefined = undefined;
  imageUrl: undefined | string;
  nextActionId: string = '';
  isNew: boolean = true;
}

export const DndWrapper = React.memo((props: any) => {
  const [context, setContext] = useState<any>(null);

  useEffect(() => {
    setContext(document.getElementById(props.id))
  },[props.id])

  return context ? (
      <DndProvider backend={HTML5Backend} options={{ rootElement: context }}>
          {props.children}
      </DndProvider>
  ) : null;
});

const defaultModalStyles = {
  content: {
    background: '#323544',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    border: 'none',
    width: '450px',
    transform: 'translate(-50%, -50%)',
  }
};

const customStyles = {
  content: {
    background: '#323544',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    border: 'none',
    width: '480px',
    transform: 'translate(-50%, -50%)',
  }
};

const customStylesLarge = {
  content: {
    background: '#323544',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    border: 'none',
    width: '640px',
    transform: 'translate(-50%, -50%)'
  }
};

Modal.setAppElement('#root');

export type MainProps = {
  intervalHandler: (command: string, gameId: string, inGame: boolean) => void
};

const INJECT_NODE_UI_PROPS = [
  'coaEditOpen', 'coaOpen', 'descEditOpen', 'descHeight', 'descOpen', 'hasCoa', 'infoEditOpen',
  'infoOpen', 'isEditing', 'isHovering', 'isNew', 'rfiEditOpen', 'rfiOpen','ttlOpen', 'x', 'y',
]

const INJECT_NODE_COA_UI_PROPS = ['x', 'y', 'isNew']
const INJECT_NODE_RFI_UI_PROPS = ['isNew']

const IGNORED_INJECT_PROPS = [
  'description', 'name', 'editMode', 'hasCoa', 'image', 'imageUrl', 'injectId',
  'isChanged', 'isEmpty', 'isNew', 'isSelected', 'localImage', 'v', 'startTurn', 'turnOrder',
];
const IGNORED_SCHEDULED_INJECT_PROPS = [
  'owner', 'public', 'published', 'sharedWith', 'inject', 'global', 'id', 'nextActionId',
  'description', 'name', 'editMode', 'hasCoa', 'image', 'imageUrl', 'injectId', 'isChanged',
  'isEmpty', 'isNew', 'isSelected', 'localImage', 'v', 'length', 'turnLength',
];

const SCENARIO_IGNORED_PROPS = [
  'name', 'description', 'images', 'injects', 'keywords', 'localImages',
  'totalRoles', 'version', 'v', 'tags', 'briefing', 'roles',
];

export interface INodeTurnHeight {
  nodeId: string;
  turn: number;
  height: number;
}

const Main: React.FC<MainProps> = ({ intervalHandler }) => {

  const [injectComponents, setInjectComponents] = useState<IInject[]>([]);
  let [injectItem, setInjectItem] = useState<IInject>(new Inject(new NewInjectObj()));
  const [saveLayouts, setSaveLayouts] = useState<{ [index: string]: any[] }>({injects: []});
  const [toDelete, setToDelete] = useState<IInject[]>([]);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState<boolean>(false);
  const [cannotDeleteScenarioModalIsOpen, setCannotDeleteScenarioModalIsOpen] = useState<boolean>(false);
  let [snippetModalIsOpen, setSnippetModalIsOpen] = useState<boolean>(false);
  let [modalNoScenarioIsOpen, setModalNoScenarioIsOpen] = useState<boolean>(false);
  let [modalShowNoNameIsOpen, setModalShowNoNameIsOpen] = useState<boolean>(false);
  let [modalPublishedIsOpen, setModalPublishedIsOpen] = useState<boolean>(false);
  let [modalPublishedInjectIsOpen, setModalPublishedInjectIsOpen] = useState<boolean>(false);
  let [sideMenu1Selected, setSideMenu1Selected] = useState<string>('');
  let [sideMenu3Selected, setSideMenu3Selected] = useState<string>('');
  let [showSettings, setShowSettings] = useState<string>('hide');
  let [showLanding, setShowLanding] = useState<string>('hide');
  let [showTimeline, setShowTimeline] = useState<string>('visible');
  let [showNodeTimeline, setShowNodeTimeline] = useState<string>('hidden');
  let [showNodeInjMenu, setShowNodeInjMenu] = useState<string>('hide');
  let [showSideMenu, setShowSideMenu] = useState<string>('show');
  let [showDeleteBtn, setShowDeleteBtn] = useState<string>('hide');
  let [showActionsMenu, setShowActionsMenu] = useState<string>('show');
  let [showMiniTimeline, setShowMiniTimeline] = useState<string>('show');
  let [showRGLTimeline, setShowRGLTimeline] = useState<string>('visible');
  let [lastInjectId, setLastInjectId] = useState<string>('')
  let [errorArray, setErrorArray] = useState<string[]>([]);
  const [ updateErrors, setUpdateErrors] = useState<string[]>([]);
  const notifyError = (errMsg: string) => {
    setUpdateErrors(updateErrors.concat(errMsg));
  }
  let [selectedScenario, setSelectedScenario] = useState<IScenario>(new Scenario({}));
  let [zoomLevel, setZoomLevel] = useState<number>(4);
  let [draggedDot, setDraggedDot] = useState<string>('');
  let [selectedSnippet, setSelectedSnippet] = useState<number>(0);
  let [scenSnippets, setScenSnippets] = useState<TurnBrief[]>([]);
  let [settingsBody, setSettingsBody] = useState<string>('');
  let [lastUserClick, setLastUserClick] = useState<string>("");
  
  let [nodeTurnHeight, setNodeTurnHeight] = useState<string>("");
  let [nodeTurnHeightArray, setNodeTurnHeightArray] = useState<INodeTurnHeight[]>([]);
  const [saveSnippetLoading, setSaveSnippetLoading] = useState<boolean>(false);
  const [newSnippet, setNewSnippet] = useState<ITurnBrief>(new TurnBrief());
  const [snippetError, setSnippetError] = useState<boolean>(false);
  const [dotDragging, setDotDragging] = useState<boolean>(false)
  const [createInjectLoading, setCreateInjectLoading] = useState<boolean>(false);
  const [lastSave, setLastSave] = useState<ILastSave>(new LastSave());
  const [nodeSaving, setNodeSaving] = useState<{ injectId: string, nodeId: string, saving: boolean }>({ injectId: '', nodeId: '', saving: false });
  
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { userId } = useAppSelector((state: any) => state.auth)

  const queryParameters = new URLSearchParams(window.location.search)
  const scenarioId: string | null = queryParameters.get("scenarioid")
  const showPanel: string | null = queryParameters.get("showpanel")

  const games: IGameStatus[] = useAppSelector(selectGamesSlice);

  async function getInjects1(scenId: string) {
    const scenariosResp = await dispatch(fetchScenarios());
    const { myScenarios } = scenariosResp.payload;
    const matchScenario = myScenarios.find((s: any) => s.id === scenId);
    if (!matchScenario) {
      return;
    }

    const newInjectsResp: any = await dispatch(fetchInjects(scenId));
    setScenSnippets(newInjectsResp?.payload.snippets)
    const createdInjComponents = await createInjectComponents(newInjectsResp?.payload.injects);
    setInjectComponents(createdInjComponents);
    setSelectedScenario(new Scenario(matchScenario));
  }

  const onSnippetFocus = useCallback((evt: React.FocusEvent<HTMLTextAreaElement>) => {
    const box = evt.currentTarget;
    box.style.height = `${box.scrollHeight}px`;
  }, [])

  const showNodeTimelineRef = useRef<any>()
  useEffect(() => {
    showNodeTimelineRef.current = showNodeTimeline
  });

  const showTimelineRef = useRef<any>()
  useEffect(() => {
    showTimelineRef.current = showTimeline
  });

  useEffect(() => {

    window.history.pushState(null, document.title, window.location.href);

    window.addEventListener('popstate', function (event)
    {
      
      if (showNodeTimelineRef.current === 'show') {
        clickManageTimeline()
      }

      if (showTimelineRef.current === 'visible') {
        clickSettings()
      }
      window.history.pushState(null, document.title, window.location.href);
    });

  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const selectedScenarioRef = useRef<any>()
  useEffect(() => {
    selectedScenarioRef.current = selectedScenario
  });

  const injectComponentsRef = useRef<any>()
  useEffect(() => {
    injectComponentsRef.current = injectComponents
  });

  const injectItemRef = useRef<any>()
  useEffect(() => {
    injectItemRef.current = injectItem
  });

  const lastSaveRef = useRef<any>()
  useEffect(() => {
    lastSaveRef.current = lastSave
  });

  const saveLayoutsRef = useRef<any>()
  useEffect(() => {
    saveLayoutsRef.current = saveLayouts
  }, [saveLayouts]);
  
  const doFullSave = useRef<any>();
  doFullSave.current = async (tempInjects: IInject[]) => {
    console.log("***DOFULLSAVE***")
    const allInjects: IInject[] = tempInjects.length > 0 ? tempInjects : injectComponentsRef.current;
    const schedInjects: IScheduledInjects[] = allInjects.map((inject) => {
      const schedInject: IScheduledInjects = new ScheduledInjects();
      if (inject.id.length < 4) {
        schedInject.injectId = '';
        schedInject.isNew = true;
      } else {
        schedInject.injectId = inject.id;
        schedInject.isNew = false;
      }

      schedInject.id = inject.id;
      schedInject.name = inject.name;
      schedInject.description = inject.description;
      schedInject.startTurn = inject.startTurn + 1;
      schedInject.turnOrder = inject.turnOrder;

      if (injectItem.injectId === inject.injectId && !isEmpty(injectItem.injectId)) {
        inject.turnLength = injectItem.turnLength + 0;
        schedInject.length = injectItem.turnLength + 0;
      } else {
        schedInject.length = inject.turnLength;
      }

      if (inject.injectId === undefined) {
        inject.injectId = '';
      }

      const layout = saveLayoutsRef.current.injects.find((il: any) => il.i === inject.id);
      if (layout) {
        schedInject.startTurn = layout.x + 1;
        schedInject.turnOrder = layout.y;
        inject.startTurn = layout.x + 1;
        inject.turnOrder = layout.y;
      }

      if (injectItem.id === inject.id) {
        schedInject.length = injectItemRef.current.turnLength;
        inject.turnLength = injectItemRef.current.turnLength;
      }

      return schedInject;
    })

    let localScenario: IScenario = JSON.parse(JSON.stringify(selectedScenarioRef.current));
    
    if (isEmpty(localScenario.owner)) {
      localScenario.owner = userId;
    }
    localScenario.injects = schedInjects;
    let createScenarioResp: any;
    let updateScenarioResp: any;
    let createInjectsResp: any;
    let saveNodesResp: any[] = [];
    let updateInjectsResp: any[] = [];

    if (selectedScenarioRef.current.id.length === 0) {
      createScenarioResp = await dispatch(createScenario(localScenario))
      if (createScenarioResp && createScenarioResp.payload.errors) {
        setErrorArray(createScenarioResp.payload.errors);
      }
      navigate(`/scenariocreator?scenarioid=${createScenarioResp.payload.scenario.id}&showpanel=settings`, { replace: false });
      setSelectedScenario({
        ...new Scenario(createScenarioResp.payload.scenario), 
        firstSave: true,
      });
    } else {
      const endTurns = allInjects.map((i) => i.startTurn + i.turnLength - 1);
      localScenario.gameTimeInterval = Math.max(...endTurns, localScenario.gameTimeInterval);
      updateScenarioResp = await dispatch(updateScenario(localScenario));
      if (isAxiosError(updateScenarioResp.payload)) {
        setUpdateErrors(updateErrors.concat(updateScenarioResp.payload.response.data.errors));
      }
    }

    let scenId: string = '';

    if (createScenarioResp !== undefined) {
      scenId = createScenarioResp.payload.scenario.id;
    }

    if (updateScenarioResp !== undefined) {
      scenId = updateScenarioResp.meta.arg.id;
    }

    if (!isEmpty(selectedScenarioRef.current.id)) {
        let newInjects: IScheduledInjects[] = [];
        for (let i = 0; i<schedInjects.length; i++) {
          newInjects.push(schedInjects[i]);
        }
        if (newInjects.length > 0) {
          createInjectsResp = await dispatch(createInjects({ scenarioId: selectedScenarioRef.current.id, injects: newInjects}));
        }
      } else if (!isEmpty(createScenarioResp.payload.scenario.id)) {
        if (schedInjects.length > 0) {
          let newInjects: IScheduledInjects[] = [];
          for (let i = 0; i<schedInjects.length; i++) {
            newInjects.push(schedInjects[i]);
          }
          if (newInjects.length > 0) {
            createInjectsResp = await dispatch(createInjects({ scenarioId: createScenarioResp.payload.scenario.id, injects: newInjects}));
          }
        }
      }

      if (!isEmpty(createInjectsResp)) {
        for (let k = 0; k<allInjects.length; k++) {
          if (isEmpty(allInjects[k].injectId)) {
            for (let l = 0; l<createInjectsResp.payload.injects.length; l++) {
              if (allInjects[k].id === createInjectsResp.payload.injects[l].id) {
                allInjects[k].injectId = createInjectsResp.payload.injects[l].injectId;
              }
            }
          }
        }
      }

      let injectUpdates: IInjInfo[] = [];
      for (let i = 0; i<allInjects.length; i++) {
        if (allInjects[i].isChanged) {
          let injUpd: IInjInfo = {};
          injUpd.injectId = allInjects[i].injectId;
          injUpd.id = allInjects[i].id;
          injUpd.name = allInjects[i].name;
          injUpd.description = allInjects[i].description;
          injUpd.global = allInjects[i].global;
          injUpd.localImage = allInjects[i].localImage;
          injUpd.turnLength = allInjects[i].turnLength;
          injUpd.sharedWith = [];
          injUpd.tags = [];
          injectUpdates.push(injUpd);
        }
      }

      if (injectItem.isChanged && !isEmpty(injectItem.id)) {
        let injUpd: IInjInfo = {};
        injUpd.id = injectItem.id;
        injUpd.injectId = injectItem.injectId;
        injUpd.name = injectItem.name;
        injUpd.description = injectItem.description;
        injUpd.global = injectItem.global;
        injUpd.localImage = injectItem.localImage;
        injUpd.turnLength = injectItem.turnLength;
        injUpd.sharedWith = [];
        injUpd.tags = [];
        injectUpdates.push(injUpd);
      }

      if (injectUpdates.length > 0) {
        await Promise.all(injectUpdates.map(async (injUpd: IInjInfo) => {
          const updateInjResp = await dispatch(updateInject(injUpd))
          if (updateInjResp.meta.requestStatus !== 'fulfilled') {
            updateInjectsResp.push(false);
          } else {
            updateInjectsResp.push(updateInjResp.payload);
          }
        }))
      }

      let createNodesArray: any[] = [];
      for (let i = 0; i<allInjects.length; i++) {
        let createNode: ICreateNode = new CreateNode();
        let tempInject: IInject = new Inject({});
        if (injectItem.id !== '') {
          tempInject = injectItemRef.current;
        } else {
          tempInject = allInjects[i];
        }
          createNode.injectId = tempInject.injectId;
          createNode.name = tempInject.name;
          for (let j = 0; j<tempInject.nodes.length; j++) {
              let newNode: INewNode = new NewNode();
              newNode.id = tempInject.nodes[j].id;
              newNode.name = tempInject.nodes[j].name;
              newNode.turn = tempInject.nodes[j].turn;
              newNode.description = tempInject.nodes[j].description;
              newNode.informationBriefs = tempInject.nodes[j].informationBriefs;
              newNode.startTurn = tempInject.nodes[j].startTurn;
              let newCoas: INewCOA[] = [];
              for (let k = 0; k<tempInject.nodes[j].coas.length; k++) {
                let newCoa: INewCOA = new NewCOA();
                  newCoa.id = tempInject.nodes[j].coas[k].id;
                  newCoa.displayText = tempInject.nodes[j].coas[k].displayText;
                  newCoa.nextNodeId = tempInject.nodes[j].coas[k].nextNodeId;
                  newCoas.push(newCoa);
              }
              newNode.coas = newCoas;

              let newRfis: IRFI[] = [];
              for (let k = 0; k<tempInject.nodes[j].rfis.length; k++) {
                let newRfi: IRFI = new RFI();
                if (tempInject.nodes[j].rfis[k] !== undefined) {
                    newRfi.id = tempInject.nodes[j].rfis[k].id;
                    newRfi.displayText = tempInject.nodes[j].rfis[k].displayText;
                    newRfi.nextNodeId = tempInject.nodes[j].rfis[k].nextNodeId;
                    newRfi.roleContent = tempInject.nodes[j].rfis[k].roleContent;
                    newRfis.push(newRfi);
                }
              }
              newNode.rfis = newRfis;

              newNode.timeToLive = tempInject.nodes[j].timeToLive;
              createNode.nodes.push(newNode);
          }
          createNodesArray.push(createNode);
        }

        await Promise.all(createNodesArray.map(async (createNode: ICreateNode) => {
          if (!isEmpty(createNode.nodes)) {
            const updateNodesResp = await dispatch(updateNodes(createNode));
            if (updateNodesResp.meta.requestStatus !== 'fulfilled') {
              saveNodesResp.push(false);
            } else {
              saveNodesResp.push({
                id: createNode.injectId,
                nodes: updateNodesResp.payload,
              });
            }
          }
        }))

        await getInjects1(scenId)
        const lastSave: ILastSave = new LastSave();

        if (!isEmpty(createScenarioResp)) {
          lastSave.scenario = new Scenario(createScenarioResp.payload);
          lastSave.scheduledInjects = createScenarioResp.payload.injects;
        }

        if (!isEmpty(updateScenarioResp)) {
          lastSave.scenario = new Scenario(updateScenarioResp.payload);
        }

        if (saveNodesResp.length > 0) {
          lastSave.nodes = saveNodesResp;
          if (saveNodesResp.length > 0) {
            saveNodesResp.forEach((nodeSaveMeta) => {
              nodeSaveMeta.nodes.forEach((node: IInjectNode) => {
                setNodeSaving({ injectId: nodeSaveMeta.id, nodeId: node.id, saving: false });
              })
            });
          }
        }

        if (!isEmpty(createInjectsResp)) {
          const newInjectsResp: any = await dispatch(fetchInjects(scenarioId));
          const { injects } = newInjectsResp.payload;
          lastSave.scheduledInjects = injects;
          let regInjects1: IInject[] = injects;
          let regInjects2: IInject[] = [];

          for (let i = 0; i<regInjects1.length; i++) {
            let newInject: IInject = new Inject(regInjects1[i].inject);
            newInject.injectId = newInject.id;
            newInject.startTurn = regInjects1[i].startTurn;
            newInject.turnOrder = regInjects1[i].turnOrder;
            newInject.isNew = false;
            regInjects2.push(newInject);
          }
          lastSave.injects = regInjects2
          lastSave.injects.forEach((inject: any) => {
            saveNodesResp.forEach((injNode: any) => {
              if (inject.injectId === injNode.id) {
                inject.nodes = injNode.nodes;
              }
            })
          })
          lastSave.snippets = createInjectsResp.payload.snippets;
        }

        console.log(lastSave);
        setLastSave(lastSave);
        
        return scenId
  }

  const onChangeSave = useMemo(
    () => debounce(() => {
      console.log('Change Save Triggered');
      doFullSave.current([]);
    }, 2000)
  ,[]);

  const saveScenario = useCallback(async (injects: IInject[]) => {
    console.log('Manual Save Triggered');
    onChangeSave.cancel();
    await doFullSave.current(injects);
  },[onChangeSave]);

  useEffect(() => {
    if (selectedScenario.id !== '' && lastSave.scenario.id !== '' && lastSave.scenario.id !== undefined) {
      setTimeout(() => {
        const orginal = omit(lastSaveRef.current.scenario, SCENARIO_IGNORED_PROPS);
        const update = omit(selectedScenario, SCENARIO_IGNORED_PROPS);
        if (!isEqual(orginal, update)) {
          saveScenario([]);
        }
      }, 1000);
    }
  }, [selectedScenario, lastSaveRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (lastSave.injects.length < injectComponents.length) {
      return;
    }

    if (lastSave.injects.length === 0 || injectComponents.length === 0) {
      console.log('Bail zero length:', lastSave.injects.length, injectComponents.length);
      return;
    }

    const sanitizedCurrent = injectComponents.map((inject: IInject) => {
      return omit(inject, IGNORED_INJECT_PROPS);
    });

    const sanitizedLast =  lastSave.injects.map((inject: any) => {
      return omit(inject, IGNORED_INJECT_PROPS);
    });

    if (!isEqualWith(sanitizedLast, sanitizedCurrent)) {
      const filteredCurrent = injectComponents.map((inject: IInject) => {
        const filtered : any = omit(inject, IGNORED_SCHEDULED_INJECT_PROPS)
        filtered.nodes = filtered.nodes?.map((n: INewNode) => {
          return {
            ...(omit(n, INJECT_NODE_UI_PROPS)),
            coas: (n.coas as INewCOA[]).map((c: INewCOA) => omit(c, INJECT_NODE_COA_UI_PROPS)),
            rfis: n.rfis.map((r: IRFI) => omit(r, INJECT_NODE_RFI_UI_PROPS)),
          }
        })
        return filtered
      });

      const filteredLast = lastSave.scheduledInjects.map((inject) => {
        const filtered = omit(inject, IGNORED_SCHEDULED_INJECT_PROPS);
        if (inject.inject) {
          filtered.nodes = inject.inject.nodes;
        }
        return  filtered;
      });

      if (!isEqualWith(filteredCurrent, filteredLast)) {
        setTimeout(async () => {
          setNodeSaving({ injectId: nodeSaving.injectId, nodeId: nodeSaving.nodeId, saving: false });
          saveScenario([]);
        }, 0)
        return;
      }
    }

    if (!isEqualWith(
      injectComponents.map((inject: IInject) => {
        if (inject.id === injectItem.id) {
          return  omit(injectItem, IGNORED_INJECT_PROPS);
        } else {
          return  omit(inject, IGNORED_INJECT_PROPS);
        }
      }),
      sanitizedLast,
      injectCustomizer,
    )) {
      const filteredCurrent = injectComponents.map((inject: IInject) => {
        const filtered : any = omit(inject, IGNORED_SCHEDULED_INJECT_PROPS);
        filtered.nodes = filtered.nodes?.map((n: INewNode) => {
          return {
            ...(omit(n, INJECT_NODE_UI_PROPS)),
            coas: (n.coas as INewCOA[]).map((c: INewCOA) => omit(c, INJECT_NODE_COA_UI_PROPS)),
            rfis: n.rfis.map((r: IRFI) => omit(r, INJECT_NODE_RFI_UI_PROPS)),
          };
        })
        return filtered;
      });
      const filteredLast = lastSave.scheduledInjects.map((inject) => {
        const filtered = omit(inject, IGNORED_SCHEDULED_INJECT_PROPS);
        if (inject.inject) {
          filtered.nodes = inject.inject.nodes;
        }
        return  filtered;
      });

      if (!isEqualWith(filteredCurrent, filteredLast)) {
        setTimeout(async () => {
          setNodeSaving({ injectId: nodeSaving.injectId, nodeId: nodeSaving.nodeId, saving: false })
          await saveScenario([]);
        }, 0);
        return;
      }
    }
  }, [injectComponents]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setToDelete(
      injectComponents.filter(i => i.isSelected === 'selected')
    );
  }, [injectComponents]); // eslint-disable-line react-hooks/exhaustive-deps

  const closePublishedModal = () => {
    setModalPublishedIsOpen(false);
  }

  const closePublishedInjectModal = () => {
    setModalPublishedInjectIsOpen(false);
  }

  const openNoScenarioModal = () => {
    setModalNoScenarioIsOpen(true);
  }

  const closeNoScenarioModal = () => {
    setModalNoScenarioIsOpen(false);
  }

  const closeShowNoNameModal = () => {
    setModalShowNoNameIsOpen(false);
  }

  const openDeleteModal = () => {
    if (selectedScenario.published) {
      return;
    }

    setToDelete(
      injectComponents.filter(i => i.isSelected === 'selected')
    );
    setDeleteModalIsOpen(true);
  }

  const afterOpenModal = () => {
    //subtitle!.style.color = '#fff';
  }

  const closeDeleteModal = (ev: React.MouseEvent) => {
    let showHide = {
      showDeleteBtn: 'hide',
      showActionsMenu: 'show',
    }
    updateShowHide(showHide);
    setDeleteModalIsOpen(false);
    setLastUserClick('');
  }

  const closeSnippetModal = () => {
    setSnippetModalIsOpen(false);
  }

  const createInject1 = async (ev: React.MouseEvent) => {
    
    if (selectedScenario.published) {
      return;
    }

    setCreateInjectLoading(true);
    let turnInjArr: number[] = [];
    let newTurnOrder: number = 0;
    for (let i = 0; i<injectComponents.length; i++) {
      if (injectComponents[i].startTurn === 1) {
        turnInjArr.push(injectComponents[i].turnOrder);
      }
    }

    newTurnOrder = turnInjArr.length === 0 ? 0 : Math.max(...turnInjArr) + 1;

    let injObj: IInject = new Inject({});
    injObj.id = (injectComponents.length + 1).toString();
    injObj.injectId = '';
    injObj.turnLength = 1;
    injObj.image = "";
    injObj.description = "";
    injObj.localImage = "";
    injObj.name = 'New Inject ' + (injectComponents.length + 1);
    injObj.startTurn = 1;
    injObj.turnOrder = newTurnOrder;
    let newNode = new InjectNode();
    let newVotingOption = new COA({});

    let coaIds: number[] = [];
    injectItem.nodes.forEach((node: IInjectNode) => {
      node.coas.forEach((coa: ICOA) => {
        coaIds.push(coa.id);
      })
    })

    if (coaIds.length === 0) {
      newVotingOption.id = 1;
    } else {
      newVotingOption.id = (Math.max(...coaIds) + 1);
    }

    newVotingOption.displayText = '';
    newVotingOption.nextNodeId = '';
    newVotingOption.isNew = true;

    newNode.id = '1';
    newNode.description = '';
    newNode.name = 'Default Node 1';
    newNode.coas.push(newVotingOption);
    newNode.timeToLive = null;
    newNode.turn = 1;
    newNode.isNew = true;
    newNode.startTurn = 1;
    injObj.nodes = [newNode];
    injObj.isNew = true;

    const tempInjects: IInject[] = [...injectComponents, new Inject(injObj)].map((inj) => {
      const layout = saveLayouts.injects.find(li => li.i === inj.id);
      if (!layout) {
        return inj;
      }
      return {
        ...inj,
        turnLength: layout.w,
        turnOrder: layout.y,
        startTurn: layout.x + 1,
      }
    });

    setInjectComponents(tempInjects);

    setTimeout(async () => {
      onChangeSave.cancel();
      await doFullSave.current(tempInjects);
      setCreateInjectLoading(false);
    }, 500)
  }

  const deleteInjects = async (ev: React.MouseEvent) => {
    ev.stopPropagation();
    let injs : IInject[] = [];
    if (toDelete.length > 0) {
      injs = toDelete;
    }
    else {
      injs = injectComponents.filter((inj) => inj.isSelected === 'selected');
    }

    const injIdsToRemove = injs.map(i => i.id);
    setInjectComponents(injectComponents.filter((data: any) => !injIdsToRemove.includes(data.id)));
    if (injIdsToRemove.includes(lastInjectId)) {
      setLastInjectId('');
    }

    const injDels = injIdsToRemove.map((injId) => dispatch(deleteInject(injId)));
    await Promise.all(injDels);

    const event: any = new Event('click');
    closeDeleteModal(event);
  }

  const updateShowHide = (showHideObj: any) => {
    setShowSettings(showHideObj.showSettings || showSettings);
    setShowLanding(showHideObj.showLanding || showLanding);
    setShowTimeline(showHideObj.showTimeline || showTimeline);
    setShowNodeTimeline(showHideObj.showNodeTimeline || showNodeTimeline);
    setShowNodeInjMenu(showHideObj.showNodeInjMenu || showNodeInjMenu);
    setShowRGLTimeline(showHideObj.showRGLTimeline || showRGLTimeline);
    setShowMiniTimeline(showHideObj.showMiniTimeline || showMiniTimeline);
    setShowSideMenu(showHideObj.showSideMenu || showSideMenu);
    setShowDeleteBtn(showHideObj.showDeleteBtn || showDeleteBtn);
    setShowActionsMenu(showHideObj.showActionsMenu || showActionsMenu);
  }

  async function selectInject(item: IInject) {
    setInjectItem(item);
    if (!isEmpty(item.injectId) && (lastInjectId !== item.injectId)) {
      setLastInjectId(item.injectId);
    }
  }

  const onExit = async () : Promise<void> => {
    if (startTurn > 1) {
      const leave = window.confirm(
        'Your Scenario Has No Inject On Turn 1. This will make your scenario unplayable. Are you sure you want to leave?');
      if (!leave) {
        throw new Error('Cancelling navigation');
      }
    }
    onChangeSave.flush();
  }

  const clickManageTimeline = async () => {
    if (!isEmpty(scenarioId)) {
      onChangeSave.cancel();

      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("showpanel", "timeline");
      window.history.replaceState(null, '', "?"+queryParams.toString());

      setSideMenu1Selected('selected');
      setSideMenu3Selected('');
      setSettingsBody('');
      let showHide = {
        showSettings: 'hide',
        showLanding: 'hide',
        showTimeline: 'visible',
        showNodeTimeline: 'hidden',
        showMiniTimeline: 'show',
        showRGLTimeline: 'visible',
        showNodeInjMenu: 'hide',
        showSideMenu: 'show',
        showDeleteBtn: 'hide',
        showActionsMenu: 'show',
      };
      updateShowHide(showHide);
      setZoomLevel(4);

      setInjectItem(new Inject({}))
      await saveScenario([]);
    } else {
      return;
    }
  }

  const clickBranches = (ev: React.MouseEvent) => {
    setSideMenu1Selected('');
    setSideMenu3Selected('');
    setSettingsBody('');
    let showHide = {
      showSettings: 'hide',
      showLanding: 'hide',
      showTimeline: 'hidden',
      showNodeTimeline: 'show',
      showMiniTimeline: 'hide',
      showRGLTimeline: 'hidden',
      showNodeInjMenu: 'show',
      showSideMenu: 'show',
      showDeleteBtn: 'hide',
      showActionsMenu: 'hide',
    };
    updateShowHide(showHide);
  }

  async function selectLastInject() {
    if (isEmpty(lastInjectId)) {
      return;
    }

    const inject = injectComponents.find((i) => i.injectId === lastInjectId)
    if (!inject) {
      setLastInjectId('');
      return;
    }

    setInjectItem(inject);
    setZoomLevel(1);
    clickBranches({} as MouseEvent);
  }

  const clickSettings = async () => {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("showpanel", "settings");
    window.history.replaceState(null, '', "?"+queryParams.toString());

    setInjectItem(new Inject({}));
    setSideMenu1Selected('');
    setSideMenu3Selected('selected');
    setSettingsBody('settings');
    let showHide = {
      showSettings: 'show',
      showLanding: 'hide',
      showTimeline: 'hidden',
      showNodeTimeline: 'hidden',
      showMiniTimeline: 'hide',
      showNodeInjMenu: 'hide',
      showSideMenu: 'show',
      showDeleteBtn: 'hide',
      showActionsMenu: 'hide',
    };
    updateShowHide(showHide);
  }

  const clickAnywhere = (ev: React.MouseEvent) => {
    if (ev.target instanceof HTMLElement) {
      if (!ev.target.classList.contains('inject-content') && 
        !ev.target.classList.contains('inject-exclaim') && 
        !ev.target.classList.contains('inject-exclaim-svg') && 
        !ev.target.classList.contains('inject-image-png') && 
        !ev.target.classList.contains('inject-text') && 
        !ev.target.classList.contains('inject-title') && 
        !ev.target.classList.contains('inject-detail') && 
        !ev.target.classList.contains('inject') && 
        !ev.target.classList.contains('action-btn') && 
        !ev.target.parentElement?.classList.contains('action-btn') &&
        !ev.target.classList.contains('rgl-inject') && 
        !ev.target.classList.contains('sidemenu-icon1') && 
        !ev.target.classList.contains('sidemenu-icon1-svg') && 
        !ev.target.classList.contains('sidemenu-icon2') && 
        !ev.target.classList.contains('sidemenu-icon2-svg') && 
        !ev.target.classList.contains('sidemenu-icon3') && 
        !ev.target.classList.contains('sidemenu-icon3-svg') && 
        !ev.target.classList.contains('ReactModal__Overlay') && 
        !ev.target.classList.contains('ReactModal__Content') &&
        !ev.target.classList.contains('delete-modal-text') &&
        !ev.target.classList.contains('delete-cancel-btn') &&
        !ev.target.classList.contains('delete-confirm-btn') && 
        !ev.target.classList.contains('delete-title') &&
        !ev.target.classList.contains('inject-more-detail') &&
        !ev.target.classList.contains('inject-delete') &&
        !ev.target.classList.contains('inject-detail')
      ) {
        if (showDeleteBtn === 'show') {
          setShowActionsMenu('show');
          setShowDeleteBtn('hide');
        }
        setLastUserClick('');
        setInjectComponents(injectComponents.map(inject => {
          return { ...inject, isSelected: '' };
        }));
      }
    }
  }

  const createInjectComponents = async (injects: any[]) => {
    const newinjects: IInject[] = [];

    const injImgs: any[] = [];
    await Promise.all(injects.map(async (inj: IInject) => {
      if (inj.inject.image !== '') {
        const getImageResp = await dispatch(fetchImages(inj.inject.id));
        if (getImageResp.meta.requestStatus === 'fulfilled') {
          const injImg: any = {};
          injImg.id = inj.inject.id;
          injImg.url = getImageResp.payload.url;
          injImgs.push(injImg);
        }
      }
    }));

    for (let i = 0; i<injects.length; i++) {
      const injObj: injObjType = new injObjType();
      injObj.id = injects[i].inject.id;
      injObj.injectId = injects[i].inject.id;
      injObj.image = injects[i].inject.image;
      injImgs.forEach((injImg: any) => {
        if (injImg.id === injects[i].inject.id) {
          injObj.imageUrl = injImg.url === undefined ? '' : injImg.url;
        }
      })

      injObj.turnLength = injects[i].length;
      injObj.name = injects[i].inject.name;
      injObj.startTurn = injects[i].startTurn
      injObj.turnOrder = injects[i].turnOrder;
      injObj.turnLength = injects[i].length;
      injObj.global = injects[i].inject.global;
      injObj.localImage = injects[i].inject.localImage;
      injObj.description = injects[i].inject.description;
      injObj.nextActionId = injects[i].inject.nextActionId;
      injObj.owner = injects[i].inject.owner;
      injObj.isNew = false;
      injObj.published = injects[i].inject.published !== undefined ? injects[i].inject.published : undefined;

      let newNodes: IInjectNode[] = [];
      for (let j = 0; j<injects[i].inject.nodes.length; j++) {
          let newNode: IInjectNode = new InjectNode();
          newNode.id = injects[i].inject.nodes[j].id;
          newNode.name = injects[i].inject.nodes[j].name;
          newNode.description = injects[i].inject.nodes[j].description;
          newNode.informationBriefs = injects[i].inject.nodes[j].informationBriefs;
          newNode.descOpen = true;
          newNode.coaOpen = true;
          newNode.rfiOpen = injects[i].inject.nodes[j].rfis.length > 0 ? true : false;
          newNode.infoOpen = injects[i].inject.nodes[j].informationBriefs.length > 0 ? true : false;
          newNode.ttlOpen = injects[i].inject.nodes[j].timeToLive !== null ? true : false;
          let coaArray: ICOA[] = [];
          for (let k = 0; k<injects[i].inject.nodes[j].coas.length; k++) {
              let coaItem: ICOA = new COA({});
              coaItem.id = injects[i].inject.nodes[j].coas[k].id;
              coaItem.displayText = injects[i].inject.nodes[j].coas[k].displayText;
              coaItem.nextNodeId = injects[i].inject.nodes[j].coas[k].nextNodeId;
              coaArray.push(coaItem);
          }
          newNode.coas = coaArray;

          let rfiArray: IRFI[] = [];
          for (let k = 0; k<injects[i].inject.nodes[j].rfis.length; k++) {
              const rfiItem: IRFI = new RFI();
              rfiItem.id = injects[i].inject.nodes[j].rfis[k].id;
              rfiItem.displayText = injects[i].inject.nodes[j].rfis[k].displayText;
              rfiItem.nextNodeId = injects[i].inject.nodes[j].rfis[k].nextNodeId;
              rfiItem.roleContent = injects[i].inject.nodes[j].rfis[k].roleContent;
              rfiArray.push(rfiItem);
          }
          newNode.rfis = rfiArray;
          //newNode.rfis = injects[i].inject.nodes[j].rfis;
          newNode.timeToLive = injects[i].inject.nodes[j].timeToLive;
          newNode.startTurn = injects[i].inject.nodes[j].startTurn;
          newNode.turn = injects[i].inject.nodes[j].turn;
          newNodes.push(newNode);
      }
      injObj.nodes = newNodes;
      let inj: IInject = new Inject(injObj);
      inj.imageUrl = injObj.imageUrl === undefined ? '' :  injObj.imageUrl;
      inj.isNew = false;
      newinjects.push(inj);
    }

    return newinjects;
  }

  useEffect(() => {
    async function getInjects() {
      setCreateInjectLoading(true);
      let scenarios = await dispatch(fetchScenarios());

      let foundScenario: boolean = false;
      if (scenarios.payload.myScenarios === undefined) {
        navigate('/login');
      }

      // Don't crash if backend is not available.
      if (!scenarios.payload || !scenarios.payload.myScenarios) {
        return;
      }

      for (let i = 0; i<scenarios.payload.myScenarios.length; i++) {
          if (scenarios.payload.myScenarios[i].id === scenarioId) {
            closeNoScenarioModal();
            foundScenario = true;
            let newInjects: any = await dispatch(fetchInjects(scenarioId));
            
            setInjectComponents(await createInjectComponents(newInjects.payload.injects));
            setScenSnippets(newInjects.payload.snippets);
            setSelectedScenario(new Scenario(scenarios.payload.myScenarios[i]));

            const nodes: INodeSave[] = [];
            for (let i = 0; i<newInjects.payload.injects.length; i++) {
              let nodeItem: any = {};
              nodeItem.id = newInjects.payload.injects[i].injectId;
              nodeItem.nodes = newInjects.payload.injects[i].inject.nodes;
              nodes.push(nodeItem);
            }

            const newInjects1 = scenarios.payload.myScenarios[i].injects;
            newInjects1.forEach((inject: any) => {
              nodes.forEach((node: any) => {
                if (inject.injectId === node.id) {
                  inject.nodes = node.nodes;
                }
              })
            })

            const regInjects1: IInject[] = newInjects.payload.injects;
            const regInjects2: IInject[] = [];

            for (let i = 0; i<regInjects1.length; i++) {
              const newInject: IInject = new Inject(regInjects1[i].inject);
              newInject.startTurn = regInjects1[i].startTurn;
              newInject.turnOrder = regInjects1[i].turnOrder;
              newInject.injectId = regInjects1[i].id;
              newInject.isNew = false;

              regInjects2.push(new Inject(newInject));
            }

            setLastSave({
              ...lastSave,
              scenario: new Scenario(scenarios.payload.myScenarios[i]),
              injects: regInjects2,
              scheduledInjects: scenarios.payload.myScenarios[i].injects,
              nodes: nodes,
            });
          }
      }
      if (!foundScenario) {  
        openNoScenarioModal();
      }
      setCreateInjectLoading(false);
    }

    if (isEmpty(scenarioId)) {
      setShowSettings('show');
      setShowSideMenu('show');
      setShowActionsMenu('hide');
      setSettingsBody('settings');
      setShowMiniTimeline('hide');
      setSideMenu3Selected('selected');
    } else {
      if (showPanel === "settings") {
        clickSettings();
      } 
      if (showPanel === "timeline") {
        //clickManageTimeline()
        let showHide = {
          showSettings: 'hide',
          showLanding: 'hide',
          showTimeline: 'visible',
          showNodeTimeline: 'hidden',
          showMiniTimeline: 'show',
          showRGLTimeline: 'visible',
          showNodeInjMenu: 'hide',
          showSideMenu: 'show',
          showDeleteBtn: 'hide',
          showActionsMenu: 'show',
        };
        updateShowHide(showHide);
        setSideMenu1Selected('selected');
        setSideMenu3Selected('');
        setSettingsBody('');
        setZoomLevel(4);
        setInjectItem(new Inject({}));
      }
      getInjects();
    }

    intervalHandler("stop", "", false);
  }, [scenarioId]) // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeSnippet = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    const target = ev.currentTarget as HTMLTextAreaElement;
    if (target) { 
      let newSnippet: ITurnBrief = new TurnBrief();
      newSnippet.briefingText = target.value;
      newSnippet.turn = selectedSnippet;
      if (scenSnippets.length === 0) {
        newSnippet.images = [];
      } else {
        for (let snippet of scenSnippets) {
          if (snippet.turn === newSnippet.turn) {
            newSnippet.images = snippet.images;
            break;
          }
        }
      }
      setNewSnippet(newSnippet);
      target.style.height = 'auto'; // Setting auto first because otherwise scrollheight keeps growing even on delete.
      target.style.height = `${target.scrollHeight}px`;
    }
  }

  useEffect(() => {
    if (selectedScenario.snippets.length > 0 && saveSnippetLoading) {
      saveScenario([]);
      setSaveSnippetLoading(false);
      setScenSnippets(selectedScenario.snippets);
    }
  }, [saveSnippetLoading, selectedScenario.snippets]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveSnippets = (newSnip: ITurnBrief | null) => {

    if (saveSnippetLoading) {
      return;
    }

    let mainSnippet: ITurnBrief = newSnip === null ? newSnippet : newSnip;

    if (isEmpty(mainSnippet)) {
      setSnippetError(true);
      return;
    } else {
      setSnippetError(false);
    }

    setSaveSnippetLoading(true);

    let newSnippets: ITurnBrief[] = JSON.parse(JSON.stringify(selectedScenario.snippets));
    let foundSnippet: boolean = false;
    if (newSnippets.length > 0) {
      for (let snippet of newSnippets) {
        if (snippet.turn === mainSnippet.turn) {
          snippet = Object.assign(snippet, mainSnippet);
          foundSnippet = true;
          break;
        }
      }
      if (!foundSnippet) {
        newSnippets.push(mainSnippet);
      }
    } else {
      newSnippets.push(mainSnippet);
    }

    setSelectedScenario({
      ...selectedScenario,
      snippets: newSnippets,
    });
  }

  const clickSaveSnippets = () => {
    saveSnippets(null);
    setSaveSnippetLoading(false);
    closeSnippetModal();
  };

  const getZoomClass = (i: number) => {
    switch(i) {
      case 1:
        return 'zoom-1'
      case 2:
        return 'zoom-2'
      case 3:
        if (showActionsMenu === 'show' || showActionsMenu === '') {
          setShowActionsMenu('hide')
        }
        
        return 'zoom-3'
      case 4:
        return 'zoom-4'
      case 5:
        return 'zoom-5' 
      default:
        break;
    }
  }

  const zoomIn = async (ev: React.MouseEvent) => {
    const target = ev.currentTarget as HTMLElement;
    if (!target) {
      return;
    }

    if (zoomLevel === 1) {
      return;
    }

    const selectedInject: any = document.querySelector('.inject.selected');
    if (zoomLevel === 4 && selectedInject !== null) {
      // drill into node based on selectedInject
      setInjectComponents(injectComponents.map((inject) => {
          if (inject.isSelected === 'selected') {
            setInjectItem(inject);
            return { ...inject, isSelected: 'selected' };
          } else {
              return { ...inject, isSelected: '' };
          }
      }));

      const showHide = {
        showSettings: 'hide',
        showLanding: 'hide',
        showTimeline: 'hidden',
        showRGLTimeline: 'hidden',
        showNodeTimeline: 'show',
        showMiniTimeline: 'hide',
        showNodeInjMenu: 'show',
        showSideMenu: 'show',
        showDeleteBtn: 'hide',
        showActionsMenu: 'hide'
      };
      updateShowHide(showHide);
    }

    if (zoomLevel === 4 && selectedInject === null) {
      return;
    } else {
      if (zoomLevel < 6) {
        setZoomLevel(--zoomLevel);
      }
    }
  }

  const zoomOut = async (ev: React.MouseEvent) => {
    const target = ev.currentTarget as HTMLElement;
    if (!target) {
      return;
    }
    
    if (zoomLevel === 5) {
      return;
    }

    if (zoomLevel === 3) {
      const showHide = {
        showSettings: 'hide',
        showLanding: 'hide',
        showTimeline: 'visible',
        showRGLTimeline: 'visible',
        showNodeTimeline: 'hide',
        showMiniTimeline: 'show',
        showNodeInjMenu: 'hide',
        showSideMenu: 'show',
        showDeleteBtn: 'hide',
        showActionsMenu: 'show'
      }
      updateShowHide(showHide);
    }

    if (zoomLevel > 0) {
      setZoomLevel(++zoomLevel);
    }
  }

  const zoomReset = async (ev: React.MouseEvent) => {
    const showHide = {
      showSettings: 'hide',
      showLanding: 'hide',
      showTimeline: 'visible',
      showRGLTimeline: 'visible',
      showNodeTimeline: 'hide',
      showMiniTimeline: 'show',
      showNodeInjMenu: 'hide',
      showSideMenu: 'show',
      showDeleteBtn: 'hide',
      showActionsMenu: 'show'
    }
    updateShowHide(showHide);
    setZoomLevel(4);
  }

  const onChangePublished = async () => {
    const publishResult: any = await dispatch(publishScenario(selectedScenario.id))

    if (publishResult.meta.requestStatus === "fulfilled") {
        setSelectedScenario({
            ...selectedScenario, 
            published: !selectedScenario.published
        });
    }

    setInjectComponents(injectComponents.map((inj: IInject) => {
        return { ...inj, published: !selectedScenario.published };
    }));
  }

  const removeError = (err: string) => {
    const errors = updateErrors.slice();
    const idx = errors.lastIndexOf(err);
    if (idx > -1) {
      errors.splice(idx, 1);
      setUpdateErrors(errors);
    }
  }

  const startTurn = useMemo(() => {
    if (!injectComponents || injectComponents.length < 1) {
      return 0;
    }
    return injectComponents.reduce<number>((minTurn, inj) => Math.min(inj.startTurn, minTurn), selectedScenario.gameTimeInterval);
  }, [injectComponents, selectedScenario.gameTimeInterval]);

  const [copyScenarioModalIsOpen, setCopyScenarioModalIsOpen] = useState<boolean>(false);
  const closeCopyScenarioModal = () => {
    setCopyScenarioModalIsOpen(false);
  }

  const [copyScenarioLoading, setCopyScenarioLoading] = useState<boolean>(false);
  const onCopyScenario = async () => {
    if (copyScenarioLoading || (scenarioId === null)) {
        return;
    }

    setCopyScenarioLoading(true);
    let copyScenarioResp = await dispatch(copyScenario(scenarioId));
    if (copyScenarioResp.payload.id !== undefined) {
        setCopyScenarioLoading(false);
        window.location.href = `/scenariocreator?scenarioid=${copyScenarioResp.payload.id}`;
    }
  }

  const openCopyScenarioModal = () => {
    setCopyScenarioModalIsOpen(true);
  }

  const [deleteScenarioModalIsOpen, setDeleteScenarioModalIsOpen] = useState<boolean>(false);
  const [deleteScenarioLoading, setDeleteScenarioLoading] = useState<boolean>(false);
  const openDeleteScenarioModal = () => {
    if (games.some(g => g.scenarioId === scenarioId)) {
      setCannotDeleteScenarioModalIsOpen(true);
      return;
    }
    setDeleteScenarioModalIsOpen(true);
  }

  const closeDeleteScenarioModal = () => {
    setDeleteScenarioModalIsOpen(false);
    setCannotDeleteScenarioModalIsOpen(false);
  }

  const onDeleteScenario = async () => {
    if (deleteScenarioLoading || (scenarioId === null)) {
      return;
    }

    setDeleteScenarioLoading(true)
    const deleteScenarioResp = await dispatch(deleteScenario(scenarioId));
    if (deleteScenarioResp.meta.requestStatus === 'fulfilled') {
        window.location.href='/player';
    }
  }

  return (
   <div className={`txp-scenario-creator ${getZoomClass(zoomLevel)} ${settingsBody}`} onClick={clickAnywhere}>
      <div className={`create-inject-loading-overlay ${createInjectLoading ? 'loading' : ''}`}>
        <div className={`hosting-loader hosting-loader-60`}></div>
      </div>
        <Header selectedScenario={selectedScenario} injectItem={injectItem} intervalHandler={intervalHandler}
          onExit={onExit} onNavTimeline={clickManageTimeline} onNavSettings={clickSettings} />
      <div className="txp-sc-main">
        <div className={`txp-content`}>
          <div className={`txp-sc-sidemenu ${showSideMenu}`}>
            <button className={`sidemenu-icon3 ${sideMenu3Selected}`} onClick={clickSettings}  data-tooltip-id="settings-tooltip" data-tooltip-content="Edit Settings" data-tooltip-place="top">
              <img className="sidemenu-icon3-svg" src="img/sidemenu-icon3.svg" alt="Settings" />
            </button>
            
            <button className={`sidemenu-icon1 ${sideMenu1Selected} ${isEmpty(scenarioId) ? 'disabled' : ''}`} onClick={clickManageTimeline} data-tooltip-id="timeline-tooltip" data-tooltip-content="Edit Timeline" data-tooltip-place="top">
              <img className="sidemenu-icon1-svg" src="img/sidemenu-icon1.svg" alt="Edit Timeline" />
            </button>
            
            <div className={`sidemenu-icon2 display-only ${(injectItem.id && !sideMenu3Selected && !sideMenu1Selected) ? 'selected' : ''} ${(injectItem.id || !isEmpty(lastInjectId))? '' : 'disabled'}`} onClick={selectLastInject} data-tooltip-id="nodes-tooltip" data-tooltip-content="Edit Nodes" data-tooltip-place="top">
              <img className="sidemenu-icon2-svg" src="img/sidemenu-icon2.svg" alt="timeline" />
            </div>
          </div>

          <div className={`txp-sc-actions`}>
            {showSettings === 'show' &&
            <div className={`action-btns`}>
              <button className={`action-btn`} onClick={openCopyScenarioModal}>Copy Scenario <CopyIcon size="12"/></button>
              <button className={`delete-btn action-btn`} onClick={openDeleteScenarioModal}>Delete Scenario <DeleteIcon size="12"/></button>
            </div>
            }
            {showSettings !== 'show' && selectedScenario.published && <div style={{float: 'left', marginLeft: '60px', color: 'white', height: '48px', lineHeight: '48px'}}
              title="Locked When Published"
            >
              <LockedIcon size="28" style={{marginBottom: '-8px'}} title="Locked When Published"/> Editing Locked When Published
            </div>}
            {showActionsMenu === 'show' && !selectedScenario.published &&
            <div className={`action-btns ${showActionsMenu}`}>
              <button className={`create-inject-btn action-btn`} onClick={createInject1}>Create Inject +</button>
              {(showActionsMenu || showDeleteBtn) && (startTurn !== 1) && <span className='error-notice'>
                There is no Inject on Turn 1. Scenario will not work correctly until this is corrected.
              </span>}
            </div>
            }
            {showDeleteBtn === 'show' && !selectedScenario.published &&
            <div className={`action-btns ${showDeleteBtn}`}>
              <button className={`delete-btn action-btn`} onClick={openDeleteModal}>Delete Inject <img src="img/trash-can.svg" className="trash-can" alt="trash can" /></button>
              {(showActionsMenu || showDeleteBtn) && (startTurn !== 1) && <span className='error-notice'>
                There is no Inject on Turn 1. Scenario will not play correctly until this is corrected.
              </span>}
            </div>
}
            <div className="zoom-controls">
              <button className="zoom-in zoom-control" onClick={zoomIn}>
                <img src="img/zoom-in.svg" alt="zoom" />
              </button>
              <button className="zoom-out zoom-control" onClick={zoomOut}>
                <img src="img/zoom-out.svg" alt="zoom" />
              </button>
              <button className="zoom-reset zoom-control" onClick={zoomReset}>
                <img src="img/zoom-reset.svg" alt="zoom" />
              </button>
            </div>
          </div>
          <ScenarioSettings
            updateShowHide={updateShowHide} showSettings={showSettings} onChangeSave={onChangeSave}
            selectedScenario={selectedScenario} setSelectedScenario={setSelectedScenario}
            errorArray={errorArray} onError={notifyError}
            openCopyScenarioModal={openCopyScenarioModal} copyScenarioLoading={copyScenarioLoading}
            saveScenario={saveScenario}
          />

          <div id={myFirstId}>
            <DndWrapper id={myFirstId}>
              <TurnTimeline onChangeSave={onChangeSave} saveScenario={saveScenario} createInjectComponents={createInjectComponents} updateShowHide={updateShowHide} setInjectComponents={setInjectComponents} injectComponents={injectComponents} showTimeline={showTimeline} showNodeInjMenu={showNodeInjMenu} showMiniTimeline={showMiniTimeline} showRGLTimeline={showRGLTimeline} setInjectItem={selectInject} gameTimeInterval={selectedScenario.gameTimeInterval} clickBranches={clickBranches} injectItem={injectItem} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} scenSnippets={scenSnippets} setSnippetModalIsOpen={setSnippetModalIsOpen} setSelectedSnippet={setSelectedSnippet} selectedScenario={selectedScenario} setSelectedScenario={setSelectedScenario} saveLayouts={saveLayouts} setSaveLayouts={setSaveLayouts} lastUserClick={lastUserClick} setLastUserClick={setLastUserClick} setNewSnippet={setNewSnippet} openDeleteModal={openDeleteModal} onError={notifyError} />
            </DndWrapper>
          </div>
          
          <div id={mySecondId}>
              <DndWrapper id={mySecondId}>
                <InjectNodeMenu updateShowHide={updateShowHide} showNodeInjMenu={showNodeInjMenu} clickManageTimeline={clickManageTimeline} selectedScenario={selectedScenario} />

                <NodeTimeline updateShowHide={updateShowHide} setInjectComponents={setInjectComponents} injectComponents={injectComponents} showNodeTimeline={showNodeTimeline} showNodeInjMenu={showNodeInjMenu} showMiniTimeline={showMiniTimeline} gameTimeInterval={selectedScenario.gameTimeInterval} zoomLevel={zoomLevel} setInjectItem={selectInject} injectItem={injectItem} draggedDot={draggedDot} setDraggedDot={setDraggedDot} nodeTurnHeight={nodeTurnHeight} setNodeTurnHeight={setNodeTurnHeight} setSelectedScenario={setSelectedScenario} selectedScenario={selectedScenario} setDotDragging={setDotDragging} dotDragging={dotDragging} saveScenario={saveScenario} nodeSaving={nodeSaving} setNodeSaving={setNodeSaving} onChangeSave={onChangeSave} nodeTurnHeightArray={nodeTurnHeightArray} setNodeTurnHeightArray={setNodeTurnHeightArray} />

              </DndWrapper>
          </div>

      </div>
      <Modal
        isOpen={deleteModalIsOpen}
        shouldCloseOnOverlayClick={false}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeDeleteModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2 className="delete-title">Delete {toDelete[0]?.name}?</h2>

      {(() => {
        if (toDelete.length === 1) {
          return <div className="delete-modal-text">The {toDelete[0].name} inject and its contents will be permanently deleted.</div>
        } else if (toDelete.length === 2) {
            return <div className="delete-modal-text">The 
            {toDelete.map((item, i) => {
              if (i === 0) {
                return (<span key={i}> {item.name} and </span>)
              } else {
                return (<span key={i}> {item.name} </span>)
              }
            })}
            injects and their contents will be permanently deleted.</div>
        } if (toDelete.length > 2) {
            return <div className="delete-modal-text">The 
            {toDelete.map((item, i) => {
              if (i === 0) {
                return (<span key={i}> {item.name}, </span>)
              } else if (i < toDelete.length-1) {
                return (<span key={i}> {item.name}, </span>)
              } else if (i === toDelete.length-1) {
                return (<span key={i}> and {item.name} </span>)
              } else {
                return <></>;
              }
            })}
            injects and their contents will be permanently deleted.</div>
        }
      })()}

        <button onClick={closeDeleteModal} className="delete-cancel-btn">Keep Injects</button>
        <button className="delete-confirm-btn selected" onClick={deleteInjects}>Delete Injects</button>
      </Modal>

      <Modal
            isOpen={snippetModalIsOpen}
            onRequestClose={closeSnippetModal}
            style={customStylesLarge}
            contentLabel="Snippet Details"
            overlayClassName="inject-modal-overlay"
        >
            <div className="inject-image-text">Turn {selectedSnippet} Brief</div>

          <div className="inject-details-info">
              <div className="inject-details-label">
                <div className="inject-details-label-text">Description</div>
                <div className="inject-details-label-desc">Provide text for you Turn Brief.</div>
              </div>
              <div className="inject-details-content">
              { snippetError ? <div className="vote-reason-error">Please enter a value.</div> : <></> }
                <textarea name="inject-description" className="inject-description"  value={newSnippet.briefingText} onFocus={onSnippetFocus} onChange={onChangeSnippet} disabled={selectedScenario.published ? true : false}></textarea>
              </div>
          </div>

          <div className="inject-details-info">
            <div className="inject-details-label">
                <div className="inject-details-label-text">Image</div>
                <div className="inject-details-label-desc">Upload an image for this inject. This image is used for the inject thumbnail.</div>
              </div>
            <div className="inject-details-content">
              { !selectedScenario.published ? 
              <Dropzone setSelectedScenario={setSelectedScenario} turn={newSnippet.turn} images={newSnippet.images} selectedScenario={selectedScenario} saveScenario={saveScenario} injectComponents={injectComponents} setInjectComponents={setInjectComponents} setInjectItem={setInjectItem} injectItem={injectItem} createInjectComponents={createInjectComponents} onChangeSave={onChangeSave} setNewSnippet={setNewSnippet} newSnippet={newSnippet} type="snippets" onError={notifyError} /> : <></> }
            </div>
          </div>
          <button onClick={closeSnippetModal} className="new-cancel-btn"><span>Close</span></button>
          { !selectedScenario.published ? <button onClick={clickSaveSnippets} className={`new-confirm-btn ${saveSnippetLoading ? 'start-loading' : ''}`}>
              {saveSnippetLoading ? <div className="game-save-loader-25"></div> : <></> }
              <span>Save</span>
          </button> : <></> }
        </Modal>

      <Modal
                isOpen={modalNoScenarioIsOpen}
                onRequestClose={closeNoScenarioModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="host-scenario-text">Could not find the Scenario!</div>

                <button className="only-cancel-btn" onClick={() => navigate('/player')}>Back to Scenarios</button>
                
      </Modal>

      <Modal
                isOpen={modalShowNoNameIsOpen}
                onRequestClose={closeShowNoNameModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="host-scenario-text">Cannot Save a Scenario without a Name.</div>

                <button className="only-cancel-btn" onClick={closeShowNoNameModal}>Close</button>
                
      </Modal>

      <Modal
                isOpen={modalPublishedIsOpen}
                onRequestClose={closePublishedModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="host-scenario-text">Cannot Edit a Published Scenario.</div>

                <div className="host-scenario-content">
                  <div className="host-scenario-label">Published</div>

                  <div className="checkbox-wrapper-10">
                      <input className="tgl tgl-ios" id="cb2-121" type="checkbox" value={selectedScenario.published!.toString()} checked={selectedScenario.published} onChange={onChangePublished} />
                      <label className="tgl-btn" htmlFor="cb2-121"></label>
                  </div>
                </div>

                <button className="only-cancel-btn selected" onClick={closePublishedModal}>Close</button>
                
      </Modal>
      <Modal
                isOpen={modalPublishedInjectIsOpen}
                onRequestClose={closePublishedInjectModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="host-scenario-text">Cannot Edit a Published Inject.</div>

                <button className="only-cancel-btn selected" onClick={closePublishedInjectModal}>Close</button>
                
      </Modal>
      </div>
      <Tooltip id="settings-tooltip" className="sidemenu-tooltip" />
      <Tooltip id="timeline-tooltip" className="sidemenu-tooltip" />
      <Tooltip id="nodes-tooltip" className="sidemenu-tooltip" />
      <Tooltip id="locked-tooltip"className="sidemenu-tooltip"/>

      <Modal
          isOpen={copyScenarioModalIsOpen}
          onRequestClose={closeCopyScenarioModal}
          style={defaultModalStyles}
          contentLabel="Copy Scenario Modal"
      >
          <div className="new-modal-header" style={{width: 'calc(100% - 15px)'}}>Copy Scenario? <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeCopyScenarioModal}></img></div>
          <div className="new-modal-text">
              Are you sure you want to make a copy of this scenario?<br/>
              You will immediately be take to your copy of the scenario if you proceed.
          </div>

          <button onClick={closeCopyScenarioModal} className="new-cancel-btn"><span>Cancel</span></button>
          <button onClick={onCopyScenario} className={`new-confirm-btn ${copyScenarioLoading ? 'start-loading' : ''}`}>
              {copyScenarioLoading ? <div className="game-save-loader-25"></div> : <></> }
              <span>Copy</span>
          </button>
      </Modal>

      <Modal
        isOpen={cannotDeleteScenarioModalIsOpen}
        onRequestClose={closeDeleteScenarioModal}
        style={customStyles}
        contentLabel="Delete Scenario Error Modal"
      >
          <div className="new-modal-header">Active Scenario <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeDeleteScenarioModal}></img></div>

          <div className="new-modal-text">There are active games running this scenario. Please clear active games and try again.</div>

          <button onClick={closeDeleteScenarioModal} className="new-cancel-btn"><span>OK</span></button>
      </Modal>

      <Modal
          isOpen={deleteScenarioModalIsOpen}
          onRequestClose={closeDeleteScenarioModal}
          style={customStyles}
          contentLabel="Delete Scenario Modal"
      >
          <div className="new-modal-header">Delete Scenario? <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeDeleteScenarioModal}></img></div>

          <div className="new-modal-text"><span className="modal-scenario-name">{selectedScenario.name}</span> will be removed from the Scenario Library and deleted. You cannot undo this action</div>

          <button onClick={closeDeleteScenarioModal} className="new-cancel-btn"><span>Cancel</span></button>
          <button onClick={onDeleteScenario} className={`new-confirm-btn ${deleteScenarioLoading ? 'start-loading' : ''}`}>
              {deleteScenarioLoading && <div className="game-save-loader-25"></div>}
              <span>Delete</span>
          </button>
      </Modal>

      {
        updateErrors.length > 0 &&
        <Theme theme="g100">{
          updateErrors.map((err, idx) =>
            <ToastNotification
              key={`${err}-${idx}`}
              aria-label="closes notification"
              caption="Invalid values have been reset"
              kind="error"
              onClose={() => removeError(err)}
              onCloseButtonClick={function noRefCheck(){}}
              role="status"
              statusIconDescription="notification"
              subtitle={err}
              timeout={0}
              title="Error Saving"
            />
          )
        }</Theme>
      }
    </div>
  );
}

const INJECT_NODE_PROPS_TO_IGNORE = ['border', 'coaEditOpen', 'coaOpen', 'descEditOpen', 'descHeight', 'descOpen', 'hasCoa', 'infoEditOpen', 'infoOpen', 'isEditing', 'isHovering', 'isNew', 'name', 'description', 'rfiEditOpen', 'rfiOpen', 'ttlOpen', 'x', 'y', 'v'];
function injectCustomizer(injectComponents: IInject, lastSaveInject: IInject) {
  let nodeMatch: boolean = false;
  let injectMatch: boolean = false;

  if (injectComponents.nodes !== undefined) {
    nodeMatch = (isEqualWith(
      injectComponents.nodes.map((node: any) => {
        return  omit(node, INJECT_NODE_PROPS_TO_IGNORE)
      }),
      lastSaveInject.nodes.map((node: any) => {
        return  omit(node, INJECT_NODE_PROPS_TO_IGNORE)
      }), nodeCustomizer));
  }

  if (!Array.isArray(injectComponents) && !Array.isArray(lastSaveInject)) {
    injectMatch = isEqual(omit(injectComponents, ['nodes']), omit(lastSaveInject, ['nodes']))
  } else {
    return undefined;
  }

  return (injectMatch && nodeMatch);
}

const NC_VOTE_NODE_IGNORED_PROPS = ['v', 'x', 'y', 'isNew', 'displayText'];
const NC_INFO_BRIEF_IGNORED_PROPS = ['v', 'x', 'y', 'isNew', 'role', 'displayText'];
const NC_TTL_IGNORED_PROPS = ['v', 'x', 'y'];
const NC_NODE_IGNORED_PROPS = ['coas', 'rfis', 'informationBriefs', 'timeToLive', 'x', 'y', 'v', 'isNew'];

function nodeCustomizer(injectComponentsNodes: any, lastSaveNodes: any) {
  let coaMatch: boolean = false;
  let rfiMatch: boolean = false;
  let informationBriefMatch: boolean = false;
  let timeToLiveMatch: boolean = false;
  let nodeMatch: boolean = false;

  if (injectComponentsNodes.coas !== undefined && lastSaveNodes.coas !== undefined) {
    let sortedCoas: any[] = sortBy(injectComponentsNodes.coas, ['id'])
    coaMatch = isEqual(
      sortedCoas.map((coa: any) => {
        return  omit(coa, NC_VOTE_NODE_IGNORED_PROPS)
      }),
      lastSaveNodes.coas.map((coa: any) => {
        return  omit(coa, NC_VOTE_NODE_IGNORED_PROPS)
      })
    )
  }

  if (injectComponentsNodes.rfis !== undefined  && lastSaveNodes.rfis !== undefined) {
    let sortedRfis: any[] = sortBy(injectComponentsNodes.rfis, ['id']);
    rfiMatch = isEqual(
      sortedRfis.map((rfi: any) => {
        const filteredRfi: any = omit(rfi, NC_VOTE_NODE_IGNORED_PROPS);
        return {
          ...filteredRfi,
          roleContent: filteredRfi.roleContent.map((rc: any) => omit(rc, ['displayText']))
        }
      }),
      lastSaveNodes.rfis.map((rfi: any) => {
        const filteredRfi: any = omit(rfi, NC_VOTE_NODE_IGNORED_PROPS);
        return {
          ...filteredRfi,
          roleContent: filteredRfi.roleContent.map((rc: any) => omit(rc, ['displayText']))
        }
      })
    )
  }

  if (injectComponentsNodes.informationBriefs !== undefined  && lastSaveNodes.informationBriefs !== undefined) {
    informationBriefMatch = isEqual(
      injectComponentsNodes.informationBriefs.map((infoBrief: any) => {
        return  omit(infoBrief, NC_INFO_BRIEF_IGNORED_PROPS)
      }),
      lastSaveNodes.informationBriefs.map((infoBrief: any) => {
        return  omit(infoBrief, NC_INFO_BRIEF_IGNORED_PROPS)
      })
    )
  }

  if (injectComponentsNodes.timeToLive !== undefined  && lastSaveNodes.informationBriefs !== undefined) {
    timeToLiveMatch = isEqual(
      omit(injectComponentsNodes.timeToLive, NC_TTL_IGNORED_PROPS),
      omit(lastSaveNodes.timeToLive, NC_TTL_IGNORED_PROPS)
    )
  }

  if (!Array.isArray(injectComponentsNodes) && !Array.isArray(lastSaveNodes)) {
    nodeMatch = isEqual(
      omit(injectComponentsNodes, NC_NODE_IGNORED_PROPS),
      omit(lastSaveNodes, NC_NODE_IGNORED_PROPS)
    )
  } else {
    return undefined
  }

  return (coaMatch && rfiMatch && informationBriefMatch && timeToLiveMatch && nodeMatch);
}

export default Main;
